module.exports = __webpack_public_path__ + "img/图片23.38a8eca8.png";